import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from "react";
import type { Game } from "@/mocks/games";
import PlayModal from "./PlayModal";

interface PlayContextValue {
  openPlay: (game: Game) => void;
}

const PlayContext = createContext<PlayContextValue | null>(null);

export function usePlay(): PlayContextValue {
  const context = useContext(PlayContext);
  if (!context) {
    throw new Error("usePlay must be used within a PlayProvider");
  }
  return context;
}

export function PlayProvider({ children }: { children: ReactNode }) {
  const [activeGame, setActiveGame] = useState<Game | null>(null);

  const openPlay = useCallback((game: Game) => {
    setActiveGame(game);
  }, []);

  const value = useMemo(() => ({ openPlay }), [openPlay]);

  return (
    <PlayContext.Provider value={value}>
      {children}
      <PlayModal game={activeGame} onClose={() => setActiveGame(null)} />
    </PlayContext.Provider>
  );
}